<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="明细"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
      @got="loaded"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="开始日期">
          <el-date-picker
            size="mini"
            v-model="params.StartDate"
            placeholder="请选择日期"
            clearable
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker
            size="mini"
            v-model="params.EndDate"
            placeholder="请选择日期"
            clearable
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="状态" style="margin-top:5px;">
          <el-select v-model="params.Status" @change="query()" clearable size="mini">
            <el-option :value="1" label="正常"></el-option>
            <el-option :value="0" label="停止"></el-option> 
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="LeaveDate" label="请假日期">
          <template slot-scope="{row}">
            {{$commonJs.toDateString(row.LeaveDate)}}
          </template>
        </el-table-column>
        <el-table-column prop="SectionName" label="节次"  />
        <el-table-column prop="Status" label="状态" width="90" align="center">
          <template slot-scope="{row}">
            <el-tag type="success" size="small" v-if="row.Status==1">正常</el-tag>
            <el-tag type="danger" size="small" v-else>停止</el-tag>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    // showCheckbox: {
    //   type: Boolean,
    //   default: false
    // },
    leaveid: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      api: require("@/api/st/leavedts").default,
      params: {
        LeaveId: 0,
        Status: null,
        StartDate: "",
        EndDate: "",
      },
      first: true
    };
  },
  mounted() {
    this.params.LeaveId = this.leaveid;
    this.query(this.params);
    this.$refs.list.initQueryParams.LeaveId = this.leaveid;
  },
  methods: {
    loaded(data) {
      if(this.first && data.length>0) {
        this.$emit("loaded",data[0].EndTime)
        this.first = false;
      }
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>